import '@fontsource/roboto-slab';
import '@fontsource/windsong';
import '@fontsource/oleo-script';
import 'normalize.css';
import 'prism-themes/themes/prism-material-light.css';
import './src/styles/custom-image.css';
import './src/styles/custom-charts.css';
